module.exports = __webpack_public_path__ + "img/tendertrace_logo_outline_white_final_552x66.601d8679.png";